export const GeoLocations = {
    REQUEST_GEO_LOCATIONS: 'REQUEST_GEO_LOCATIONS',
    RECEIVE_GEO_LOCATIONS: 'RECEIVE_GEO_LOCATIONS',
    REQUEST_GEO_LOCATION_POSITION: 'REQUEST_GEO_LOCATION_POSITION',
    RECEIVE_GEO_LOCATION_POSITION: 'RECEIVE_GEO_LOCATION_POSITION',
    REQUEST_GEO_LOCATION_BY_IP: 'REQUEST_GEO_LOCATION_BY_IP',
    RECEIVE_GEO_LOCATION_BY_IP: 'RECEIVE_GEO_LOCATION_BY_IP',
};
